import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import BaseMap from '../interfaces/BaseMap';
import IFilterSettings from '../interfaces/IFilterSettings';
import IVisibleLayers from '../interfaces/IVisibleLayers';

export default interface ISavedView {
    id: number;
    name: string;
    isShared: boolean;
    viewState: IUserViewState;
    modifiedDate: Date;
    createdByUser: ISavedViewUser;
    modifiedByUser: ISavedViewUser | null;
}

export interface ISavedViewResponseModel {
    id: number;
    name: string;
    isShared: boolean;
    viewStateJson: string;
    modifiedDate: string;
    createdByUser: ISavedViewUser;
    modifiedByUser: ISavedViewUser | null;
}

export interface ISavedViewIncludes {
    includeFocusArea: boolean;
    includeAllFilterSettings: boolean;
    includeVisibleLayerSettings: boolean;
    includeBaseMapSettings: boolean;
    includeCompanyIdsToViewOnMap: boolean;
}

export interface ISavedViewCreateState extends ISavedViewIncludes {
    name: string;
    isShared: boolean;
}

export class SavedViewDraft implements ISavedViewCreateState {
    id: number | null = null;
    name: string = "";
    isShared: boolean = false;

    includeFocusArea: boolean = false;
    includeAllFilterSettings: boolean = false;
    includeVisibleLayerSettings: boolean = false;
    includeBaseMapSettings: boolean = false;
    includeCompanyIdsToViewOnMap: boolean = false;

    static empty(): SavedViewDraft {
        return new SavedViewDraft();
    }
}

export interface ISavedViewUpdateState extends ISavedViewCreateState {
    id: number;
}

export interface ISavedViewCreateRequest {
    name: string;
    isShared: boolean;
    viewStateJson: string;
}

export interface ISavedViewUpdateRequest extends ISavedViewCreateRequest {
    id: number;
}

export interface ISavedViewUser {
    id: number;
    userName: string;
}

export interface IUserViewState {
    focusArea?: FeatureCollection<Geometry, GeoJsonProperties>;
    filters?: IFilterSettings;
    visibleLayers?: IVisibleLayers;
    baseMap?: BaseMap;
    companyIdsToViewOnMap?: number[];
}
